import { createHeaderTh } from './th'
import { createHeaderCell } from './cell'

// 生成th组件
const HeaderTh = createHeaderTh()
// 真实内容渲染组件
const Cell = createHeaderCell()

function getHeaderRowStyle(row, rowIndex, store) {
  const headerRowStyle = store.table.headerRowStyle
  if (typeof headerRowStyle === 'function') {
    return headerRowStyle({ row, rowIndex })
  }
  return headerRowStyle
}
function getHeaderRowClass(row, rowIndex, store) {
  const classes = []
  const headerRowClassName = store.table.headerRowClassName
  if (typeof headerRowClassName === 'string') {
    classes.push(headerRowClassName)
  } else if (typeof headerRowClassName === 'function') {
    classes.push(headerRowClassName({ row, rowIndex }))
  }
  return classes.join(' ')
}

function createHeaderCellContent (h, $props, {column, rendColumnIndex, rowIndex, handleSortChange}, {
  headerTh: thSlots,
  headerCell
}) {
  const columnIndex = column.originIndex
  const {
    store,
    handleEvent,
    headerAlign,
    headerColumnRows,
    defaultSort,
    type,
    setHeaderPopoverAttrs,
    changeHeaderPopoverVisibleStatus,
    getHeaderPopoverAttrs
  } = $props
  const { headerRender } = column
  const renderInnerCell = () => {
    const cellAttrs = {
      props: {
        column,
        store,
        columnIndex,
        rendColumnIndex,
        rowIndex,
        headerAlign,
        handleEvent,
        defaultSort,
        handleSortChange,
        setHeaderPopoverAttrs,
        changeHeaderPopoverVisibleStatus,
        getHeaderPopoverAttrs
      }
    }
    return <Cell {...cellAttrs}>
      {{
        headerCell
      }}
    </Cell>
  }
  const InnerCell = renderInnerCell()

  const createHeaderTh = () => {
    if (thSlots) {
      return thSlots
    }
    const headerThAttrs = {
      props: {
        column,
        rendColumnIndex,
        columnIndex,
        rowIndex,
        store,
        type
      }
    }
    return <HeaderTh {...headerThAttrs}>
      {
        InnerCell
      }
    </HeaderTh>
  }

  const headerTh = createHeaderTh()
  return typeof headerRender === 'function' ? headerRender(column, columnIndex, rendColumnIndex, headerColumnRows) : headerTh
}

export function createHeaderThead() {
  return {
    functional: true,
    render (h, context) {
      const { store, headerColumnRows, handleEvent } = context.props

      const handleSortChange = (column) => {
        if (store.isReadyDraging(column)) return
        store.sortChange(column)
      }

      // 插槽内容
      const [slots] = context.slots().default || []
      // 循环生成表头配置
      const hearderCellVNode = () => (
        headerColumnRows.map((cols, rowIndex) => {
          return (<tr
              style={ getHeaderRowStyle(cols, rowIndex, store) }
              class={ getHeaderRowClass(cols, rowIndex, store) }
            >
            {
              cols.map((column, rendColumnIndex) => {
                return createHeaderCellContent(h, context.props, {column, rendColumnIndex, rowIndex, handleSortChange}, slots)
              })
            }
          </tr>)
        })
      )

      const mouseleave = (event) => {
        handleEvent && handleEvent(event, { column: store.table.columns, eventType: 'thead-mouseleave' })
      }
      const mouseenter = (event) => {
        handleEvent && handleEvent(event, { column: store.table.columns, eventType: 'thead-mouseenter' })
      }
      const theadAttrs = {
        on: {
          mouseleave,
          mouseenter
        }
      }

      const cellVnode = hearderCellVNode()
      return (
        <thead {...theadAttrs}>{cellVnode}</thead>
      )
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/header-thead/index.js